import { schema, types } from 'papr'

const BETA_FEATURE_TYPE = ['user' as const, 'publication' as const]
const BETA_FEATURE_STATUS = ['active' as const, 'inactive' as const]

export const betaFeatureSchema = schema(
	{
		key: types.string({ required: true }),
		type: types.enum(BETA_FEATURE_TYPE, { required: true }),
		metaData: types.object({
			title: types.string(),
			description: types.string(),
			url: types.string(),
			/**
			 * Indicates if the feature is only available for team publications.
			 */
			team: types.boolean(),
		}),
		status: types.enum(BETA_FEATURE_STATUS, {
			required: true,
		}),
	},
	{
		defaults: {
			status: 'active',
		},
	},
)

export type BetaFeatureDocument = (typeof betaFeatureSchema)[0]
export type BetaFeatureSchemaOptions = (typeof betaFeatureSchema)[1]
